import React from 'react';
import { Form, Input, Button } from '../../styles/ManageWorkspaceMembers.styles';

const AddMemberForm = ({ email, onEmailChange, onSubmit }) => (
    <Form onSubmit={onSubmit}>
        <Input
            type="email"
            placeholder="Add member by email"
            value={email}
            onChange={e => onEmailChange(e.target.value)}
        />
        <Button type="submit" disabled={!email}>Add</Button>
    </Form>
);

export default AddMemberForm;